webpackJsonp([35783957827783],{

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(43);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _store = __webpack_require__(39);
	
	var _shared = __webpack_require__(67);
	
	var _Seo = __webpack_require__(221);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Index);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.featureNavigator = _shared.featureNavigator.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Index.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.navigatorPosition !== "is-featured") {
	      this.props.setNavigatorPosition("is-featured");
	    }
	  };
	
	  Index.prototype.render = function render() {
	    var data = this.props.data;
	
	    var facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_Seo2.default, { facebook: facebook })
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    isWideScreen: state.isWideScreen
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Index);
	
	//eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-aa9570313651ef926b5a.js